import config from "./config";

const keviApi = {
    endpoint: config.apiEndpoint,
    getOptions: function (endpoint, method, params) {
        if (method === undefined) {
            method = "GET";
        }
        if (params === undefined) {
            params = {};
        }
        return {
            url: this.endpoint + "/" + endpoint,
            method: method,
            params: params,
        };
    },
};

export default keviApi;
